/**
 * Navigation menu items for the left sidebar.
 *
 * Each item defines a route destination and its visual representation.
 * Icons are referenced by name and mapped to actual components in the sidebar.
 */

export const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: 'home', path: '/home' },
  { id: 'golive', label: 'Go Live!', icon: 'broadcast', path: '/go-live' },
  { id: 'message', label: 'Message', icon: 'chat', path: '/messages' },
  { id: 'community', label: 'Community', icon: 'community', path: '/community' },
  { id: 'upload', label: 'Upload', icon: 'upload', path: '/upload' },
  { id: 'subscriptions', label: 'Subscriptions', icon: 'star', path: '/subscriptions' },
];

/**
 * Profile dropdown menu items.
 *
 * Defines actions available in the user profile dropdown.
 * 'divider' type creates a visual separator between item groups.
 */
export const PROFILE_MENU_ITEMS = [
  { id: 'profile', label: 'Your Profile', icon: 'user', path: '/profile' },
  { id: 'divider', type: 'divider' },
  { id: 'logout', label: 'Log Out', icon: 'logout', action: 'logout' },
];
